import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FormItem, { FormItemType } from '../FormItem'

type FormProps = {
    form: FormItemType[]
    paddingX?: number
}

const Form: FunctionComponent<FormProps> = ({ form, paddingX = 1 }) => {
    if (!form.length) {
        return null
    }
    return (
        <Grid width={96} horizontal noExpand>
            {form.slice(0, 5).map((item, index) => (
                <Grid key={`form-grid-${item}-${index}`} paddingX={paddingX}>
                    <FormItem key={`form-${item}-${index}`} type={item} />
                </Grid>
            ))}
        </Grid>
    )
}

export default Form
